import createClient from 'openapi-fetch';
import { getBaseUrl } from '@/lib/env';
import { createAcceptLanguageMiddleware } from './accept-language-middleware';
import { createAuthMiddleware } from './auth-middleware';
import type { paths } from './schema';
const apiClient = createClient<paths>({
  baseUrl: getBaseUrl(),
  credentials: 'include',
  // 304(空ボディ)を fetch が復元できずエラー化するため、HTTP キャッシュは使わない（キャッシュは TanStack Query が担当）。
  cache: 'no-store'
});
apiClient.use(createAcceptLanguageMiddleware());
const authMiddleware = createAuthMiddleware();
apiClient.use(authMiddleware);
export { apiClient };